import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, Spinner } from '@a-ui/react';
import { fetchNotificationsPreferences, addNotificationSetting, removeNotificationSetting, addNotificationsPref, removeNotificationsPref, registerNotificationToken } from '../../store/slices/notificationReducer';
import { requestNotifications } from '../../helpers/notifications.helper';
import './NotificationsPrefs.scss';

const NotificationsPrefs = (props) => {
  const dispatch = useDispatch();
  const [showPush, setShowPush] = useState(false);
  const [hidePush, setHidePush] = useState(false);
  const { user } = useSelector(state => state.user);
  const [swRegistered, setSwRegistered] = useState(false);
  const { loading, settings } = useSelector(state => state.notifications);

  async function hasFirebaseServiceWorker() {
    const serviceworkers = await navigator.serviceWorker.getRegistrations();
    const firebaseServiceworker = serviceworkers.find((sw) => sw.active.scriptURL.endsWith('firebase-messaging-sw.js'));
    return !!firebaseServiceworker;
  }

  useEffect(() => {
    dispatch(fetchNotificationsPreferences());
    hasFirebaseServiceWorker().then((result) => setSwRegistered(result));
  }, [dispatch]);

  function changePref(channel, contextName, checked) {
    if (checked) {
      // Remove
      dispatch(removeNotificationsPref({id: checked, language: 'nl', userId: user.id})).then(response => {
        dispatch(removeNotificationSetting({ channel, contextName, response }));
      });
    } else {
      // Add
      dispatch(addNotificationsPref({contextName, channel, language: 'nl', userId: user.id})).then(response => {
        dispatch(addNotificationSetting(response.payload));
      });
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }


  async function activateNotifications() {
    const { activate, token } = await requestNotifications();
    setShowPush(activate);
    setHidePush(!activate);
    dispatch(registerNotificationToken(token));
  }
  const browserSupportsNotifications = ("Notification" in window);
  const showRequestButton = browserSupportsNotifications && ((Notification.permission === "default") || (Notification.permission === "granted" && !swRegistered));

  return <div className="u-margin-bottom u-margin-left u-margin-right u-margin-top-xs">
    {loading && <Spinner/>}
    <div className="o-notifications__preferences">{settings.allPreferences && Object.entries(settings.allPreferences).map(([key, value]) => {

      // Handle push notifications
      if (key === 'push' && !showPush) {
        if (browserSupportsNotifications && showRequestButton && !hidePush) {
          return <fieldset className="a-input u-margin-top-l" key={key+value}>
              <legend className="a-input__label">{capitalizeFirstLetter(key)}</legend>
              <p className="small u-margin-bottom-xs">Om gebruik te maken van push meldingen, dien je deze eerst te activeren. Na activatie kan je ook de instellingen hiervan aanpassen.</p>
              <p>
                <Button
                  emphasis="medium"
                  addOn={{
                    type: "icon",
                    align: "left",
                    iconProps: {
                      name: "ai-alarm-bell",
                    },
                  }}
                  onClick={() => activateNotifications()}>
                  Push meldingen activeren
                </Button>
              </p>
            </fieldset>;
        } else if((("Notification" in window) && Notification.permission === "denied") || hidePush) {
          return <fieldset className="a-input u-margin-top-l" key={key+value}>
              <legend className="a-input__label">{capitalizeFirstLetter(key)}</legend>
              <p className="small u-margin-bottom-xs">De activatie van push meldingen werden geweigerd op dit toestel. Activeer deze in je browserinstellingen.</p>
            </fieldset>;
        }
      }

      return <fieldset className="a-input u-margin-top-l" key={key+value}>
        <legend className="a-input__label">{capitalizeFirstLetter(key)}</legend>
        <p className="small u-margin-bottom-xs">Ontvang een {key} notificatie wanneer:</p>
        {value.map((item, j) => {
          let obj = { name: item, id: undefined };
          if (settings.myPreferences.hasOwnProperty(key)) {
            obj = settings.myPreferences[key].find(obj => obj.name === item) || { name: item, id: undefined };
          }
          return <Checkbox
            key={key + '-' + j}
            id={key + '-' + j}
            label={item}
            name={key + '-' + j}
            checked={!!obj.id}
            onChange={() => changePref(key, item, obj.id)}
          />
        })}
      </fieldset>;
    })}
    </div>
  </div>
}

export default NotificationsPrefs;
